import { PLATFORMS } from '@domain/platform/platform.types';
import { ENUM_FIELD_OPERATORS, MULTI_OPTIONS_OPERATORS } from '@domain/campaigns/campaigns-filter/campaigns-filter.types';
import { FIELD } from './rules.types';

export const FIELD_NAME_BY_PLATFORM = {
    [FIELD.STATUS]: {
        [PLATFORMS.GOOGLE_ADS]: 'status',
        [PLATFORMS.FACEBOOK_ADS]: 'status',
    },
};

export const PARETO_REPORT_VALUE_TO_PLATFORM_VALUE = {
    [PLATFORMS.GOOGLE_ADS]: {
        [FIELD.STATUS]: {
            active: ['enabled'],
            paused: ['paused'],
        },
    },
    [PLATFORMS.FACEBOOK_ADS]: {
        [FIELD.STATUS]: {
            active: ['enabled'],
            paused: ['paused'],
        },
    },
};

const ENUM_OPERATOR_IN = (campaign, { field, value }) => (
    PARETO_REPORT_VALUE_TO_PLATFORM_VALUE[campaign.platform][field][value].includes(
        campaign[FIELD_NAME_BY_PLATFORM[field][campaign.platform]],
    )
);
// Após MultiSelect
// const ENUM_OPERATOR_IN = (campaign, { field, value }) => (
//     value.map(v => PARETO_REPORT_VALUE_TO_PLATFORM_VALUE[campaign.platform][field][v])
//         .includes(
//             campaign[FIELD_NAME_BY_PLATFORM[field][campaign.platform]],
//         )
// );

const isCampaignIncluded = (campaign, value, opts = { getNotIncluded: false }) => {
    const ids = value.map(opt => opt.value);
    const { getNotIncluded } = opts;

    const campaignIncluded = ids.includes(campaign.campaign_id);

    if (getNotIncluded) {
        return campaignIncluded ? null : campaign;
    }

    return campaignIncluded ? campaign : null;
};

export const CALLBACK_BY_OPERATOR = {
    [ENUM_FIELD_OPERATORS.IN]: ENUM_OPERATOR_IN,
    [ENUM_FIELD_OPERATORS.NOT_IN]: (campaign, { field, value }) => (
        !ENUM_OPERATOR_IN(campaign, { field, value })
    ),
    [MULTI_OPTIONS_OPERATORS.IN]: (campaign, { value }) => isCampaignIncluded(campaign, value),
    [MULTI_OPTIONS_OPERATORS.NOT_IN]: (
        campaign,
        { value },
    ) => isCampaignIncluded(campaign, value, { getNotIncluded: true }),
};
